import { memo } from 'react';
import logo from '../../assets/images/logo.png';
import { Button, Text } from '../../components';
import {
  scrollToElement,
  WHO_WE_ARE_ID,
  ABOUT_US_ID,
  ONLINE_BUSINESS_CONSULTING_ID,
  GET_IN_TOUCH_FORM_ID
} from '../../utils';
import './Header.scss';
import { BurgerMenu } from './BurgerMenu/BurgerMenu';

const MemoComponent = () => {
  const navLinks = [
    { label: 'Who we are', link: WHO_WE_ARE_ID },
    { label: 'About Us', link: ABOUT_US_ID },
    { label: 'Services', link: ONLINE_BUSINESS_CONSULTING_ID },
  ];

  return (
    <nav className="header">
      <div className="header-content display-flex space-between align-items-center">
        <img src={logo} alt="logo" className="display-block logo"/>

        <div className="nav-links display-flex justify-center align-items-center gap-30">
          {navLinks.map((item, index) => (
            <Text
              key={item.label}
              variant="content2"
              className="as-link"
              weight={700}
              onClick={() => scrollToElement(item.link)}
            >
              {item.label}
            </Text>
          ))}
        </div>

        <Button
          label="Contact"
          className="contact-button"
          size="sm" onClick={() => scrollToElement(GET_IN_TOUCH_FORM_ID)}
        />

        <BurgerMenu navItems={[ ...navLinks, { label: 'Contact', link: GET_IN_TOUCH_FORM_ID } ]}/>
      </div>
    </nav>
  );
};

export const Header = memo(MemoComponent);